import React, { useRef, useState } from "react";
import { get } from "../../../constants/apiRoutes";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const Tabs = () => {
  const [activeTab, setActiveTab] = useState("tab2");
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [goldData, setGoldData] = useState([]);
  const [data, setData] = useState([]);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const headings = [
    "Ounce (USD) ",
    "24K Rate (AED)",
    "22K Rate (AED) ",
    "21K Rate (AED) ",
    "18K Rate (AED) ",
    "14K Rate (AED) ",
    "Timestamp",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData(startDate, endDate);
  };

  const fetchData = async (startDate, endDate) => {
    try {

      const endpoint =
        activeTab === "tab1" ? `Broadcast/goldrates` : `Broadcast/history`;
      const params = { startDate, endDate };

      const response = await get(endpoint, params);
      const Data = response.reverse();
      activeTab === "tab1" ? setData(Data) : setGoldData(Data);

    } catch (error) {
      console.error(`Error While Fetching Filtered Data ${error}`);
    }
  };

  const handleExport = (exportData) => {
    if (exportData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(exportData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");

      XLSX.writeFile(wb, "broadcast-history.xlsx");

      Swal.fire({
        icon: "success",
        title: "Exported successfully.",
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "No Data Available.",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleDateChange = (e) => {
    const { id, value } = e.target;
    if (id === "startDate") {
      setStartDate(value);
    } else if (id === "endDate") {
      setEndDate(value);
    }
  };
  const handleDateRangeSelection = (range) => {
    const today = new Date();
    let start, end;

    switch (range) {
      case "Today":
        start = new Date(today);
        end = new Date(today);
        break;

      case "Yesterday":
        start = new Date(today);
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;

      case "ThisMonth":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        start.setDate(start.getDate() + 1);
        end.setDate(end.getDate() + 1);
        break;

      case "Last30Days":
        start = new Date(today);
        start.setDate(today.getDate() - 30);
        end = new Date(today);
        start.setDate(start.getDate());
        end.setDate(end.getDate());
        break;

      case "Last90Days":
        start = new Date(today);
        start.setDate(today.getDate() - 90);
        end = new Date(today);
        start.setDate(start.getDate());
        end.setDate(end.getDate());
        break;

      case "ThisYear":
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today);
        start.setDate(start.getDate());
        end.setDate(end.getDate());
        break;

      case "LastYear":
        start = new Date(today.getFullYear() - 1, 0, 1);
        end = new Date(today.getFullYear() - 1, 11, 31);
        start.setDate(start.getDate());
        end.setDate(end.getDate());
        break;

      case "CustomPeriod":
        if (startDateRef.current) {
          startDateRef.current.focus();
        }
        return;

      default:
        return;
    }

    setStartDate(start.toISOString().split("T")[0]);
    setEndDate(end.toISOString().split("T")[0]);

    fetchData(
      start.toISOString().split("T")[0],
      end.toISOString().split("T")[0]
    );
  };

  return (
    <div className="wsData border-2 p-4 rounded-xl my-3 mx-10">
      <div className="tabs flex mb-8 justify-between">
        <div className="tabs-cont">
          {/* <button
            className={`border-2 p-2 rounded-lg font-semibold  m-2 text-white ${
              activeTab === "tab1" ? "bg-yellow-700" : "bg-gray-400"
            }`}
            onClick={() => setActiveTab("tab1")}
          >
            Ounce
          </button> */}
          <button
            className={`p-2 text-sm bg-yellow-700 rounded-lg font-semibold m-2 text-white ${
              activeTab === "tab2" ? "bg-yellow-700" : "bg-gray-400"
            }`}
            onClick={() => setActiveTab("tab2")}
          >
            Broadcast History
          </button>
        </div>
        <div>
          <form
            onSubmit={handleSubmit}
            className=" p-2 mx-2 flex flex-row items-center gap-4"
          >
            <label className="text-black w-fit text-sm font-semibold">
              Select Range :
            </label>
            <select
              onChange={(e) => handleDateRangeSelection(e.target.value)}
              className="focus:outline-none text-xs border-2 text-center px-1 rounded-lg h-10 w-40 m-1"
            >
              <option value="">-- Select --</option>
              <option value="Today">Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="ThisMonth">This Month</option>
              <option value="Last30Days">Last 30 Days</option>
              <option value="Last90Days">Last 90 Days</option>
              <option value="ThisYear">This Year</option>
              <option value="LastYear">Last Year</option>
              <option value="CustomPeriod">Custom Period</option>
            </select>

            <label
              htmlFor="startDate"
              className="text-black w-fit text-sm font-semibold"
            >
              Start :
            </label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              ref={startDateRef}
              onChange={(e) => {
                handleDateChange(e);
                if (endDateRef.current) {
                  endDateRef.current.focus();
                }
              }}
              required
              className="focus:border-blue-500 focus:outline-none text-xs border-2 px-1 rounded-lg h-10 m-1"
            />
            <label
              htmlFor="endDate"
              className="text-black text-sm font-semibold flex items-center "
            >
              End :
            </label>

            <input
              type="date"
              id="endDate"
              value={endDate}
              ref={endDateRef}
              onChange={handleDateChange}
              required
              className="focus:border-blue-500 focus:outline-none  text-xs border-2 px-1 rounded-lg h-10 m-1 "
            />
            <div className="">
              <button
                type="submit"
                title="Fetch Broadcast"
                className="border-2 border-gray-800 rounded-full outline-none focus:outline-none mx-2 p-2"
              >
                <svg
                  className="w-6 h-6 text-gray-800 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z"
                    clipRule="evenodd"
                  />
                  <path
                    fillRule="evenodd"
                    d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                onClick={() =>
                  handleExport(activeTab === "tab1" ? data : goldData)
                }
                title="Export To Excel"
                className="border-2 border-gray-800 rounded-full outline-none focus:outline-none mx-2 p-2"
              >
                <svg
                  className="w-6 h-6 text-gray-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v9.293l-2-2a1 1 0 0 0-1.414 1.414l.293.293h-6.586a1 1 0 1 0 0 2h6.586l-.293.293A1 1 0 0 0 18 16.707l2-2V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="overflow-x-auto">
        {activeTab === "tab1" && (
          <table className="table table-zebra w-full text-center">
            <thead className="bg-base-200">
              <tr className="bg-orange-100 rounded-lg">
                {headings.map((heading, index) => (
                  <th
                    className={`!important text-black py-2 px-4 ${
                      index === 0 ? "rounded-tl-lg" : ""
                    } ${index === headings.length - 1 ? "rounded-tr-lg" : ""}`}
                    key={index}
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={index}>
                    <td>{row.usdounz}</td>
                    <td>{row.rate24Karat}</td>
                    <td>{row.rate22Karat}</td>
                    <td>{row.rate21Karat}</td>
                    <td>{row.rate18Karat}</td>
                    <td>{row.rate14Karat}</td>

                    <td>
                      {new Date(
                        row.timestamp ? row.timestamp : row.dateInserted
                      ).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
        {activeTab === "tab2" && (
          <table className="table table-zebra w-full text-center ">
            <thead className="bg-base-200">
              <tr className="bg-orange-100 rounded-lg">
                {headings.map((heading, index) => (
                  <th
                    className={` text-black py-2 px-4 ${
                      index === 0 ? "rounded-tl-lg" : ""
                    } ${index === headings.length - 1 ? "rounded-tr-lg" : ""}`}
                    key={index}
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-xs">
              {goldData.length > 0 ? (
                goldData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.usdounz}</td>
                    <td>{row.rate24Karat}</td>
                    <td>{row.rate22Karat}</td>
                    <td>{row.rate21Karat}</td>
                    <td>{row.rate18Karat}</td>
                    <td>{row.rate14Karat}</td>

                    <td>
                      {new Date(
                        row.timestamp ? row.timestamp : row.dateInserted
                      ).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Tabs;
